export enum PLURID_ICON_SIZES {
    small = 'small',
    normal = 'normal',
    large = 'large',
}
